let unlocked = false;
let sentAudio: HTMLAudioElement | null = null;
let receivedAudio: HTMLAudioElement | null = null;

function ensureAudio() {
  if (!sentAudio) {
    sentAudio = new Audio("/sounds/sendedMessage.WAV");
    sentAudio.volume = 0.45;
    sentAudio.preload = "auto";
  }
  if (!receivedAudio) {
    receivedAudio = new Audio("/sounds/receivedMessage.WAV");
    receivedAudio.volume = 0.5;
    receivedAudio.preload = "auto";
  }
}

/** Unlock audio after a user gesture (browser autoplay policy). */
export function unlockChatSounds() {
  if (unlocked || typeof window === "undefined") return;
  ensureAudio();
  unlocked = true;
  const nudge = (audio: HTMLAudioElement | null) => {
    if (!audio) return;
    const prev = audio.volume;
    audio.volume = 0;
    audio
      .play()
      .then(() => {
        audio.pause();
        audio.currentTime = 0;
        audio.volume = prev;
      })
      .catch(() => {
        audio.volume = prev;
      });
  };
  nudge(sentAudio);
  nudge(receivedAudio);
}

async function play(audio: HTMLAudioElement | null) {
  if (!audio || typeof document === "undefined") return;
  if (document.hidden) return;
  try {
    audio.currentTime = 0;
    await audio.play();
  } catch {
    // Autoplay blocked until unlockChatSounds runs from a gesture.
  }
}

export function playSentSound() {
  ensureAudio();
  return play(sentAudio);
}

export function playReceivedSound() {
  ensureAudio();
  return play(receivedAudio);
}
